// extracted by mini-css-extract-plugin
export default {"cls1":"CitationModal-cls1___b0e5c4e940d10720ec4","cls2":"CitationModal-cls2___91d41855fdbac58f6f4 CitationModal-cls1___b0e5c4e940d10720ec4"};